import { createSlice } from '@reduxjs/toolkit';
import { THEME_TYPES } from '../constants/theme';
import { getThemeStore, setThemeStore } from '../../utils/storage/store';
import { getTheme } from '../../utils/theme';

const initialState = {
    themeId: getThemeStore()?.key || ''
};

export const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setTheme: (state, action) => {
            const themeObj = getTheme(action.payload);
            state.themeId = action.payload;
            setThemeStore(themeObj);
            //localStorage.setItem('themeId', action.payload);

            // document.body.className = themeObj.name;


            document.documentElement.style.setProperty('--adm-color-primary', themeObj.color);
            document.documentElement.style.setProperty('--adm-color-primary-hover', themeObj.otherColor);
        }
    }
});

export const { setTheme } = themeSlice.actions;
export const selectTheme = (state) => state.theme.themeId;
export default themeSlice.reducer;